


















































import Vue, { PropType } from 'vue';
import { Column } from '@/components/table/types';
import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
import Preloader from '@/components/preloader/Preloader.vue';
import toLocaleString from '@/utils/toLocaleString';

export default Vue.extend({
  name: 'ValueTable',
  components: {
    FieldCheckbox,
    Preloader,
  },

  props: {
    column: {
      type: Object as PropType<Column>,
    },
    value: {
      type: [String, Number],
      required: false,
    },
    nRow: {
      type: Number,
    },
    nColumn: {
      type: Number,
    },
    hoverRow: {
      type: Boolean,
      default: false,
    },
    expandEnable: {
      type: Boolean,
      default: false,
    },
    expandOpen: {
      type: Boolean,
      default: false,
    },
    checkboxEnable: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    selectedRows: {
      type: Array,
      default: () => [],
    },
  },

  watch: {
    checked(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.checkboxValue = newValue;
      }
    },
  },

  computed: {
    showExpandButton(): boolean {
      return (
        this.expandEnable &&
        this.nColumn === 0 &&
        this.column.field === 'id' &&
        (this.hoverRow || this.expandOpen)
      );
    },
    checked(): boolean {
      return this.selectedRows.some((row) => row == this.value);
    },
    checkboxIsShow(): boolean {
      return (
        this.checkboxEnable &&
        this.nColumn === 0 &&
        (this.hoverRow || this.checkboxValue)
      );
    },
  },

  methods: {
    changeExpand() {
      this.isExpanded = !this.isExpanded;
      this.$emit('changeExpand');
    },
    changeChecked() {
      this.$emit('changeChecked', {
        checked: this.checkboxValue,
        value: this.value,
      });
    },
    formatValue(value: number) {
      if (this.column.field !== 'id' && !this.column.field.includes('_id')) {
        return toLocaleString(value);
      }

      return value;
    },
  },

  data: function () {
    return {
      isExpanded: false,
      checkboxValue: false,
    };
  },
});
